import styles from './menu.module.sass';
import { DetailedHTMLProps, HtmlHTMLAttributes } from 'react';

export type Link = {
    text: string;
    link: string;
    image?: string;
    target?: '_blank' | '_self';
};

export interface MenuProps extends DetailedHTMLProps<HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    navLinks?: Link[];
    LinkComponent?: any;
}

export const Menu = ({ navLinks, LinkComponent, ...props }: MenuProps) => {
    return (
        <nav id={styles.nav} {...props}>
            <ul>
                {navLinks &&
                    navLinks.map((link, index) => (
                        <li key={link.link || index}>
                            <LinkComponent
                                href={link.link}
                                data-test-id={`footer-link-${link.text.toLowerCase().replace(/\s+/g, '-')}`}
                                {...(link.target ? { target: link.target } : null)}
                            >
                                {link.text || ''}
                            </LinkComponent>
                        </li>
                    ))}
            </ul>
        </nav>
    );
};
